import React, {useState, useEffect} from 'react';
import { Button, Input, Divider, Form } from 'semantic-ui-react'
import { Link, Redirect } from "react-router-dom";
import {sceneList} from "../index"


const Intro = () => {
	const secretCode = "HALLOWEENTIME"

	const [val, setVal] = useState("")
	const [success, setSuccess] = useState(false)

	const onSubmit = () => {
		if (val == secretCode) {
			setSuccess(true)
		}
	}

		const onChange = (e) => {
		setVal(e.target.value)
	}



  return (
  	<div className="App">
    <Divider/>
      <div className="intro">
	      <h1>WELCOME</h1>
	      <h2>ARE YOU READY FOR SPOOKS?</h2>
	      <Divider hidden/>
	        <div><Input className="intro" onChange={onChange} placeholder='Input Code' /></div>
	        <Divider hidden style={{marginTop:"-3px"}}/>
	        <Button className="default spookButton" onClick={onSubmit} type="submit">Click Here</Button>
			{ success && <Redirect to={sceneList[0].path} sceneIndex={0}/> }
		</div>
    </div>
  );
}

export default Intro;
